import React from 'react';
import ThemePageBanner from '../../dashboardNew/components/ThemePageBanner';
import ToDoList from '../../dashboardNew/components/ToDoList';
import StarsSection from '../../dashboardNew/components/StarsSection';
import {authenticatedGetRequest} from "../../../helpers/requests";

export class StarsPage extends React.Component {

    state = {
        todoList: null
    }

    componentWillMount() {
        authenticatedGetRequest(`/profiles/${ localStorage.getItem('person_id') }/todo-list`)
            .then( result => this.setState({ todoList : result.data }, () => this.fixedScrollSideBar()) )
            .catch( console.error );
    }

    fixedScrollSideBar() {

        // Height of wrapper of page
        const contentWrapperDocument = document.getElementsByClassName('stars-page-wrapper');
        const heaightOfDoc = contentWrapperDocument[0].offsetHeight;

        // Finds elements and distance
        const sideBarContent = document.getElementsByClassName('inner-star-side')[0];
        const heaightOfSideBarContent = sideBarContent.offsetHeight;
        const sideBarPosition = sideBarContent.getBoundingClientRect().top + window.scrollY + 20;

        // Scroll function
        window.onscroll = function () {

            const offset = 100;
            const scrollPosY = window.pageYOffset | document.body.scrollTop;
            const position = ((scrollPosY + offset) - sideBarPosition);

            // somewhere in the middle
            if( (scrollPosY + offset) > sideBarPosition ){ sideBarContent.style.transform = "translateY(" + position + "px)" };
            
            // harry i've reached the top
            if( (scrollPosY + offset) <= sideBarPosition ){ sideBarContent.style.transform = "translateY(0)" };

            // harry i've reached the bottom
            sideBarContent.classList[ scrollPosY >= (heaightOfDoc - heaightOfSideBarContent - 65) ? 'add' : 'remove' ]( 'active' );
        };
        
    }

    scrollToSection = (id) => {
        let elem = document.getElementById(id);
        let topPos = elem.getBoundingClientRect().top + window.scrollY;
        window.scroll({
            behavior: 'smooth',
            left: 0,
            top: topPos - 85
        });
        elem.classList.add('selected');
        setTimeout(() => {
            elem.classList.remove('selected');
        }, 1000);
    };

    render() {
        const todoList = this.state.todoList;

        const starSectionItems = todoList && todoList.map((content, key) => {
        // console.log(content)
           return <StarsSection
                key={key}
                id={key}
                heading={content.item_name}
                bodyCopy={content.description}
                expires={content.todo_list_people[0] && content.todo_list_people[0].expires_at}
                ctaText={content.cta_text}
                ctaLink={content.cta_link}
            />
        }
        );

        return (
            <div className="portal-page-wrapper stars-page-wrapper">
                <ThemePageBanner
                    image='/images/stars.jpg'
                    heading='stars'
                />

                <div className="container stars-page">
                    <div className="row">
                        <div className="col-12 col-xl-8 theme-page-content">
                            <div className="intro">
                                <h2 className="heading-two">What are the stars?</h2>

                                <p className="body-copy">As a member of In Touch, we want you to get maximum value from
                                    the portal, which is why we have a star rating system to help you progress in your
                                    professional development and career. The more tasks that you complete from your
                                    to-do list on the right, the more
                                    stars you will receive. 10-star members will get more visibility to external
                                    recruiters
                                    visiting the portal as they will be featured on the first and second page of search
                                    results.</p>

                                <p className="body-copy">Please note, your star rating can fluctuate depending on your
                                    level of engagement. For
                                    example, if you watch a webinar then fail to tune into a webinar the following month
                                    then this star will disappear. We want you to remain engaged and constantly
                                    in-the-know.</p>

                                <p className="body-copy">By carrying out each of the tasks below, you will increase your
                                    star rating and,
                                    ultimately, your engagement with the network.</p>

                            </div>

                            {starSectionItems}

                        </div>
                        <div className="col-12 col-xl-4 theme-page-sidebar">
                            <div className="inner-star-side">
                                <ToDoList
                                    scrollToSection={this.scrollToSection}
                                    todoList={this.state.todoList}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
};



// WEBPACK FOOTER //
// src/client/components/site/pages/StarsPage.js